// src/components/rules/RulesAcknowledgment.js
import React, { useState } from 'react';
import { supabase } from '../../config/supabase.config';

function RulesAcknowledgment({ rules, userData, onAcknowledge, onClose }) {
  const [agreed, setAgreed] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleAcknowledge = async () => {
    if (!agreed) {
      alert('Please agree to the rules before proceeding');
      return;
    }

    setLoading(true);
    try {
      const { error } = await supabase
        .from('rule_acknowledgments')
        .insert([{
          resident_id: userData.id,
          acknowledged_at: new Date().toISOString(),
          ip_address: 'N/A'
        }]);

      if (error) throw error;
      
      alert('Thank you for acknowledging the community rules!');
      onAcknowledge();
    } catch (error) {
      console.error('Error acknowledging rules:', error);
      alert('Failed to save acknowledgment');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: 'white',
        borderRadius: '10px',
        width: '90%',
        maxWidth: '600px',
        maxHeight: '90vh',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <div style={{
          padding: '20px',
          borderBottom: '1px solid #ddd'
        }}>
          <h3 style={{ margin: 0 }}>📋 Community Rules Acknowledgment</h3>
        </div>
        
        <div style={{
          flex: 1,
          overflow: 'auto',
          padding: '20px'
        }}>
          <p style={{ marginBottom: '20px', color: '#666' }}>
            Please read and acknowledge the following community rules:
          </p>
          
          <div style={{
            maxHeight: '300px',
            overflow: 'auto',
            border: '1px solid #ddd',
            borderRadius: '5px',
            padding: '15px',
            marginBottom: '20px',
            background: '#f8f9fa'
          }}>
            {rules.map((rule, index) => (
              <div key={rule.id} style={{ marginBottom: '15px' }}>
                <strong>{index + 1}. {rule.title}</strong>
                <p style={{ margin: '5px 0', color: '#666', fontSize: '14px' }}>
                  {rule.description}
                </p>
              </div>
            ))}
          </div>
          
          <label style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: '10px',
            cursor: 'pointer'
          }}>
            <input
              type="checkbox"
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
              style={{ marginTop: '3px' }}
            />
            <span>
              I have read, understood, and agree to abide by all the community rules and regulations. 
              I understand that violation of these rules may result in fines or other penalties.
            </span>
          </label>
        </div>
        
        <div style={{
          padding: '20px',
          borderTop: '1px solid #ddd',
          display: 'flex',
          gap: '10px'
        }}>
          <button
            onClick={handleAcknowledge}
            disabled={!agreed || loading}
            style={{
              flex: 1,
              padding: '12px',
              background: agreed && !loading ? '#28a745' : '#ccc',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: agreed && !loading ? 'pointer' : 'not-allowed',
              fontWeight: '600'
            }}
          >
            {loading ? 'Processing...' : 'I Agree & Acknowledge'}
          </button>
          <button
            onClick={onClose}
            disabled={loading}
            style={{
              padding: '12px 20px',
              background: '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
          >
            Later
          </button>
        </div>
      </div>
    </div>
  );
}

export default RulesAcknowledgment;